module.exports = __webpack_public_path__ + "media/images/icons/character-development-66965fd7f5188c8655f2a88f463fa3d8.svg";